import React, { forwardRef } from "react";
import classNames from "classnames";
import IStyledProps from "../../utilities/IStyledProps";
import IEditableProps from "../../utilities/IEditableProps";

function Header({ name, title }) {
    return (
        <div className="d-md-block d-none mlo-name">
            <h1>{name}</h1>
            <h3 className="text-muted text-serif">{title}</h3>
        </div>
    );
}

export interface IBioProps extends IEditableProps, IStyledProps {
    name: string;
    title: string;
    children?: any;
}

const Bio = forwardRef((props: IBioProps, ref: any) => {
    return (
        <div className={classNames(props.editorClassObj)} ref={ref} data-id={props.cmsId}>
            <Header name={props.name} title={props.title} />
            <div className={classNames(props.className, "mlo-bio")}>
                {props.children}
            </div>
        </div>
    );
});

export default Bio;